var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.isAddGuestPopupOpened,
      "no-close-button": _vm.step === 'permissions'
    },
    on: {
      "close": _vm.close
    }
  }, [_vm.step === 'add_guest' ? _c('div', [_c('div', {
    staticClass: "mx-5 xl:mx-44 2xl:mx-40 my-8 w-auto h-auto"
  }, [_c('h3', {
    staticClass: "mb-15"
  }, [_vm._v("Ajouter un invité")]), _vm._v(" "), _c('h6', {
    staticClass: "text-indigo-600 my-5 mb-9"
  }, [_vm._v("\n        Veuillez saisir les informations du nouvel invité à ajouter\n      ")]), _vm._v(" "), _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-5"
  }, [_c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "Prénom",
      "libelle": "Prénom",
      "value": _vm.newGuest.firstname,
      "error": true,
      "msg-error": ((_vm.errors || []).firstname || [])[0],
      "required": true
    },
    on: {
      "input": function (newValue) {
        _vm.newGuest.firstname = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "Nom",
      "libelle": "Nom",
      "value": _vm.newGuest.lastname,
      "error": true,
      "msg-error": ((_vm.errors || []).lastname || [])[0],
      "required": true
    },
    on: {
      "input": function (newValue) {
        _vm.newGuest.lastname = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "libelle": "Email",
      "value": _vm.newGuest.email,
      "msg-error": ((_vm.errors || []).email || [])[0],
      "error": true,
      "required": true
    },
    on: {
      "input": function (newValue) {
        _vm.newGuest.email = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "libelle": "Fonction",
      "value": _vm.newGuest.function,
      "msg-error": ((_vm.errors || []).function || [])[0],
      "error": true
    },
    on: {
      "input": function (newValue) {
        _vm.newGuest.function = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "libelle": "Structure",
      "value": _vm.newGuest.structure,
      "msg-error": ((_vm.errors || []).structure || [])[0],
      "error": true
    },
    on: {
      "input": function (newValue) {
        _vm.newGuest.structure = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-span-full justify-self-center mt-5 flex space-x-4"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": "Droits d'accès spécifiques",
      "icon": "options",
      "right": true,
      "type-shadow": "shadow-indigo",
      "uppercase": true
    },
    on: {
      "clickAction": function ($event) {
        return _vm.permissionsStep();
      }
    }
  }), _vm._v(" "), _vm.saving_new ? _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "CREER",
      "spinner": true,
      "right": true,
      "type-shadow": "shadow-pink"
    }
  }) : _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "CRÉER",
      "icon": "arrow-right_1",
      "right": true,
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.createGuest();
      }
    }
  })], 1)], 1)])])]) : _vm.step === 'permissions' ? _c('div', [_c('div', {
    staticClass: "m-5 lg:m-15 2xl:m-20"
  }, [_c('h3', {
    staticClass: "w-full text-pink-600 mb-10"
  }, [_vm._v("Droits d'accès spécifiques")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center space-x-2 w-max transform hover:scale-110 duration-300 cursor-pointer mb-5",
    on: {
      "click": function ($event) {
        _vm.step = 'add_guest';
      }
    }
  }, [_c('div', {
    staticClass: "text-white bg-pink-600 p-3 rounded-full w-max"
  }, [_c('icon', {
    staticClass: "w-4 h-4 transform rotate-180",
    attrs: {
      "name": "arrow-right_1"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v("Retour")])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between"
  }, [_c('div', {
    staticClass: "flex-none"
  }, [_vm.listNeopassModulesPages ? _c('div', [_c('checkbox-indigo', {
    staticClass: "text-indigo-600",
    attrs: {
      "name": "Lecture",
      "libelle": "LECTURE",
      "color-libelle": "indigo-600",
      "value": ((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).read || {}).all,
      "size-libelle": "text-base"
    },
    on: {
      "input": function (newValue) {
        ((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).read || {}).all = newValue;
        _vm.checkall('read', 'all', newValue);
        if (!newValue) {
          ((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).edit || {}).all = newValue;
          _vm.checkall('edit', 'all', newValue);
        }
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l(_vm.listNeopassModulesPages.filter(function (m) {
    return m.name != _vm.constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS;
  }), function (mod, numMod) {
    return _c('div', {
      key: numMod,
      staticClass: "m-3"
    }, [_c('div', [_c('checkbox-indigo', {
      staticClass: "mb-1.5",
      attrs: {
        "name": mod.name,
        "libelle": mod.display_name,
        "value": (((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).read || {})[mod.name] || {}).all,
        "size-libelle": "text-base"
      },
      on: {
        "input": function (newValue) {
          (((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).read || {})[mod.name] || {}).all = newValue;
          _vm.checkall('read', mod.name, newValue);
          _vm.decheckall('read', mod.name, newValue);
          if (!newValue) {
            (((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).edit || {})[mod.name] || {}).all = newValue;
            _vm.checkall('edit', mod.name, newValue);
            _vm.decheckall('edit', mod.name, newValue);
          }
        }
      }
    })], 1), _vm._v(" "), _vm._l(mod.pages.filter(function (p) {
      return p.name != _vm.constants.PAGE_NEOPASS_FORM_DOCUMENTS;
    }), function (page, numPage) {
      return _c('div', {
        key: numPage
      }, [_c('checkbox-indigo', {
        attrs: {
          "name": page.name,
          "libelle": page.display_name,
          "value": (((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).read || {})[mod.name] || {})[page.name],
          "color-libelle": "text-gray-600",
          "size-libelle": "text-base",
          "weight-libelle": "font-light"
        },
        on: {
          "input": function (newValue) {
            (((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).read || {})[mod.name] || {})[page.name] = newValue;
            _vm.decheckall('read', mod.name, newValue);
            if (!newValue) {
              (((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).edit || {})[mod.name] || {})[page.name] = newValue;
              _vm.decheckall('edit', mod.name, newValue);
            }
          }
        }
      })], 1);
    }), _vm._v(" "), _vm.permissions.includes(mod.name + '_auto_eval_read') ? _c('checkbox-indigo', {
      staticClass: "text-gray-600",
      attrs: {
        "name": mod.name + '_auto_eval_read',
        "libelle": "Auto Evaluation Bénéficiaire",
        "color-libelle": "gray-600",
        "value": (((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).read || {})[mod.name] || {})['auto_eval'],
        "size-libelle": "text-base",
        "weight-libelle": "font-light"
      },
      on: {
        "input": function (newValue) {
          (((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).read || {})[mod.name] || {})['auto_eval'] = newValue;
          _vm.decheckall('read', mod.name, newValue);
          if (!newValue) {
            (((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).edit || {})[mod.name] || {})['auto_eval'] = newValue;
            _vm.decheckall('edit', mod.name, newValue);
          }
        }
      }
    }) : _vm._e()], 2);
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-grow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-none"
  }, [_vm.listNeopassModulesPages ? _c('div', [_c('checkbox-indigo', {
    attrs: {
      "name": "Ecriture",
      "libelle": "ECRITURE",
      "value": ((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).edit || {}).all,
      "color-libelle": "text-indigo-600",
      "size-libelle": "text-base"
    },
    on: {
      "input": function (newValue) {
        ((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).edit || {}).all = newValue;
        _vm.checkall('edit', 'all', newValue);
        if (newValue) {
          ((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).read || {}).all = newValue;
          _vm.checkall('read', 'all', newValue);
        }
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l(_vm.listNeopassModulesPages.filter(function (m) {
    return m.name != _vm.constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS;
  }), function (mod, numMod) {
    return _c('div', {
      key: numMod,
      staticClass: "m-3"
    }, [_c('div', [_c('checkbox-indigo', {
      staticClass: "mb-1.5",
      attrs: {
        "name": mod.name,
        "libelle": mod.display_name,
        "value": (((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).edit || {})[mod.name] || {}).all,
        "size-libelle": "text-base"
      },
      on: {
        "input": function (newValue) {
          (((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).edit || {})[mod.name] || {}).all = newValue;
          _vm.checkall('edit', mod.name, newValue);
          _vm.decheckall('edit', mod.name, newValue);
          if (newValue) {
            (((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).read || {})[mod.name] || {}).all = newValue;
            _vm.checkall('read', mod.name, newValue);
          }
        }
      }
    })], 1), _vm._v(" "), _vm._l(mod.pages.filter(function (p) {
      return p.name != _vm.constants.PAGE_NEOPASS_FORM_DOCUMENTS;
    }), function (page, numPage) {
      return _c('div', {
        key: numPage
      }, [_c('checkbox-indigo', {
        attrs: {
          "name": page.name,
          "libelle": page.display_name,
          "value": (((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).edit || {})[mod.name] || {})[page.name],
          "color-libelle": "text-gray-600",
          "size-libelle": "text-base",
          "weight-libelle": "font-light"
        },
        on: {
          "input": function (newValue) {
            (((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).edit || {})[mod.name] || {})[page.name] = newValue;
            _vm.decheckall('edit', mod.name, newValue);
            if (newValue) {
              (((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).read || {})[mod.name] || {})[page.name] = newValue;
            }
          }
        }
      })], 1);
    }), _vm._v(" "), _vm.permissions.includes(mod.name + '_auto_eval_edit') ? _c('checkbox-indigo', {
      staticClass: "text-gray-600",
      attrs: {
        "name": mod.name + '_auto_eval_edit',
        "libelle": "Auto Evaluation Bénéficiaire",
        "color-libelle": "gray-600",
        "value": (((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).edit || {})[mod.name] || {})['auto_eval'],
        "size-libelle": "text-base",
        "weight-libelle": "font-light"
      },
      on: {
        "input": function (newValue) {
          (((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).edit || {})[mod.name] || {})['auto_eval'] = newValue;
          _vm.decheckall('edit', mod.name, newValue);
          if (newValue) {
            (((((_vm.specificRightsToEdit || {}).rights || {}).neopassForm || {}).read || {})[mod.name] || {})['auto_eval'] = newValue;
          }
        }
      }
    }) : _vm._e()], 2);
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center mt-10"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "Valider",
      "icon": "checkmark-circle",
      "right": true,
      "type-shadow": "shadow-pink",
      "uppercase": true
    },
    on: {
      "clickAction": function ($event) {
        return _vm.infosGuestStep();
      }
    }
  })], 1)])]) : _vm.step === 'success' ? _c('div', [_c('div', {
    staticClass: "m-5 lg:m-15 2xl:m-20"
  }, [_c('h3', {
    staticClass: "w-full text-pink-600 mb-10"
  }, [_vm._v("Invitation envoyée !")]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          L’invitation a été transmise à " + _vm._s(_vm.newGuest.firstname) + "\n          "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.newGuest.lastname))]), _vm._v(", à l'adresse email " + _vm._s(_vm.newGuest.email) + "\n        ")])]), _vm._v(" "), _c('illustration', {
    staticClass: "w-full",
    attrs: {
      "name": "basket"
    }
  })], 1)]) : _vm.step === 'limit' ? _c('div', [_c('div', {
    staticClass: "m-5 lg:m-15 2xl:m-20"
  }, [_c('h3', {
    staticClass: "w-full text-pink-600 mb-10"
  }, [_vm._v("Un seul invité autorisé")]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          Votre compte gratuit ne vous permet d'inviter qu'une seule personne\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          Si vous souhaitez inviter plusieurs personnes simultanément, vous\n          pouvez passer à\n          "), _c('span', {
    staticClass: "cursor-pointer text-pink-600"
  }, [_vm._v("l'abonnement Premium")])])]), _vm._v(" "), _c('illustration', {
    staticClass: "w-full",
    attrs: {
      "name": "basket"
    }
  })], 1)]) : _vm.step === 'already_invited' ? _c('div', [_c('div', {
    staticClass: "m-5 lg:m-15 2xl:m-20"
  }, [_c('h3', {
    staticClass: "w-full text-pink-600 mb-10"
  }, [_vm._v("Utilisateur déjà invité")]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          Votre compte gratuit ne vous permet d'inviter une seule fois une\n          même personne\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          Si vous souhaitez inviter plusieurs fois la même personne, vous\n          pouvez passer à\n          "), _c('span', {
    staticClass: "cursor-pointer text-pink-600"
  }, [_vm._v("l'abonnement Premium")])])]), _vm._v(" "), _c('illustration', {
    staticClass: "w-full",
    attrs: {
      "name": "basket"
    }
  })], 1)]) : _c('div', [_c('div', {
    staticClass: "m-5 lg:m-15 2xl:m-20"
  }, [_c('h3', {
    staticClass: "w-full text-pink-600 mb-10"
  }, [_vm._v("\n        Erreur lors de la création de l'invité !\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          L'invité n'a pas pu être créé.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n          Veuillez contacter notre\n          "), _c('router-link', {
    staticClass: "underline hover:font-medium",
    attrs: {
      "to": "aide/contact"
    }
  }, [_vm._v("\n            service technique\n          ")]), _vm._v("\n          en indiquant l'adresse mail renseignée\n        ")], 1)]), _vm._v(" "), _c('illustration', {
    staticClass: "w-full",
    attrs: {
      "name": "notAllowed"
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }